import { useQuery } from '@tanstack/react-query';
import { getAllAdministrators, getClientAdministrators } from '../routes';

export function useGetAllAdministrators(includeInactive: boolean = false) {
  return useQuery({
    queryKey: ['get-all-administrators', includeInactive],
    queryFn: () => getAllAdministrators(includeInactive),
  });
}

export function useGetClientAdministrators(clientId: string) {
  return useQuery({
    queryKey: ['get-client-administrators', clientId],
    queryFn: () => getClientAdministrators(clientId),
  });
}
